import { createSlice } from '@reduxjs/toolkit';
import { fetchProducts, fetchProductDetails } from './productThunk';

const initialState = {
  loading: false,
  products: [],
  error: ''
};

export const listProductSlice = createSlice({
  name: 'listProduct',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchProducts.pending, (state) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(fetchProducts.fulfilled, (state, action) => {
      state.loading = false;
      state.products = Array.isArray(action.payload.data) ? action.payload.data : [];
      state.error = '';
    });
    builder.addCase(fetchProducts.rejected, (state, action) => {
      state.loading = false;
      state.products = [];
      state.error = action.payload?.response?.data?.detail || action.payload?.message || 'خطا در دریافت محصولات';
    });
  }
});

export const productDetailsSlice = createSlice({
  name: 'productDetails',
  initialState: {
    loading: false,
    product: {},
    error: ''
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProductDetails.pending, (state) => {
      state.loading = true;
      state.product = {};
      state.error = '';
    });
    builder.addCase(fetchProductDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.product = action.payload.data || {};
      state.error = '';
    });
    builder.addCase(fetchProductDetails.rejected, (state, action) => {
      state.loading = false;
      state.product = {};
      state.error = action.payload?.response?.data?.detail || action.payload?.message || 'خطا در دریافت محصول';
    });
  }
});